module.exports = __webpack_public_path__ + "static/media/pharma.78b73160.png";